import { createRoute, Outlet, redirect } from '@tanstack/react-router';

import { BlastList } from '~features/blasts';
import { rootRoute } from './__root';

/**
 * Root route for `/blasts` section and its children routes.
 */
const blastsRootRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/blasts',
  component: () => <Outlet />,
  loader: () => ({ crumb: 'Blasts' }),
});

/**
 * Index route for `/blasts/` — displays the list of blasts.
 */
const blastsIndexRoute = createRoute({
  getParentRoute: () => blastsRootRoute,
  path: '/',
  component: BlastList,
});

/**
 * Catch-all route for `/blasts/$blastName` — redirects back to the blast list.
 * !Note: Currently, there is no standalone blast detail page; users navigate to specific sub-features
 * (optimisations or hardness_domains) from the blast list.
 */
const blastNameRoute = createRoute({
  getParentRoute: () => blastsRootRoute,
  path: '$blastName',
  beforeLoad: () => {
    throw redirect({ to: '/blasts' });
  },
});

export { blastNameRoute, blastsIndexRoute, blastsRootRoute };
